const PremiumFeaturesKeys = {
  global: ["premiumFeatures"] as const,
};

export { PremiumFeaturesKeys };
